import React from "react";
import { useTheme } from "@/context/ThemeContext";
import lightLogo from "@/assets/brand/qr-code-creator-studio-light.png"; // dark navy text — for LIGHT backgrounds
import darkLogo from "@/assets/brand/qr-code-creator-studio-dark.png"; // white text — for DARK backgrounds
import iconLogo from "@/assets/brand/qr-code-creator-studio-icon.png";

// Icon-only mark (gradient QR icon on transparent bg) — safe on any theme.
export function BrandMark({ className = "h-8 w-8" }) {
  return <img src={iconLogo} alt="QR Code Creator Studio" className={className} style={{ objectFit: "contain" }} loading="eager" decoding="async" draggable={false} />;
}

// Centralized, theme-aware brand logo.
// variant: "auto" (follows global theme) | "light-bg" (force dark-text) | "dark-bg" (force white-text)
export default function Logo({ variant = "auto", iconOnly = false, className = "", alt = "QR Code Creator Studio" }) {
  const { theme } = useTheme();
  const whiteText = variant === "dark-bg" ? true : variant === "light-bg" ? false : theme === "dark";
  const src = iconOnly ? iconLogo : whiteText ? darkLogo : lightLogo;
  const alt2 = whiteText ? lightLogo : darkLogo; // preloaded so theme-toggle has no fetch flash
  return (
    <>
      <img
        src={src}
        alt={alt}
        className={`${iconOnly ? "h-9 w-9" : "h-9 sm:h-10 md:h-11 w-auto"} ${className}`}
        style={{ objectFit: "contain", maxWidth: "100%" }}
        loading="eager"
        decoding="async"
        draggable={false}
      />
      {!iconOnly && <img src={alt2} alt="" aria-hidden="true" style={{ display: "none" }} loading="eager" />}
    </>
  );
}
